import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';
class CustomAutSummaryForm extends Form {
	state: any = {
		data: {
			executiveSummary: '',
			conclusion: '',
			recommendation: '',
		},
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		executiveSummary: Joi.string().optional().label('Executive Summary'),
		conclusion: Joi.string().min(5).required().label('Conclusion / Remark'),
		recommendation: Joi.string().min(3).required().label('Recommendation'),
	};

	static propTypes = {
		initialSummaryData: PropTypes.object,
		onAdd: PropTypes.func,
	}

	componentDidMount() {
		if (this.props.initialSummaryData) {
			this.setState({ data: this.props.initialSummaryData });
		}
	}

	doSubmit = () => {
		this.props.onAdd(this.state.data);
		toastService.success('Summary saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderTextEditor({
							name: 'executiveSummary',
							label: 'Executive Summary',
							placeholder: 'Enter executive summary',
						})}
					</div>
					<div className="col">
						{this.renderTextArea({
							rows: '4',
							name: 'conclusion',
							label: 'Conclusion / Remark',
							placeholder: 'Enter Conclusion / Remark',
						})}
					</div>
					<div className="col">
						{this.renderTextArea({
							rows: '4',
							name: 'recommendation',
							label: 'Recommendation (If any)',
							placeholder: 'Enter Recommendation',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Summary Sheet Data')}
				</div>
			</form>
		);
	}
}

export default CustomAutSummaryForm;
